export const HEADER_HEIGHT = {
  mobile: 68,
  desktop: 100,
};
